import { render, staticRenderFns } from "./PayrollEditStaffSidebar.vue?vue&type=template&id=f367b18a"
import script from "./PayrollEditStaffSidebar.vue?vue&type=script&lang=js"
export * from "./PayrollEditStaffSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports